<template>
  <content-box :width="'800px'" class="no-page"
    :class="{ ja: $i18n.locale === 'ja' }">
    <div class="content__top">
      <p class="title" v-html="$t('dashboard.exhaustedPv.title')"></p>
      <p class="slogan" v-html="$t('dashboard.exhaustedPv.slogan')"></p>
      <i class="icon icon--dashboard-encourage-graph"></i>
    </div>
    <div class="content__bottom">
      <div class="button__wrap">
        <ui-button :primary="true"
                   @click="$router.push({ name: 'managePlan', params: { action: 'changePlan' } })">
          {{ $t('common.upgradePlan') }}
        </ui-button>
        <ui-button :primary4="true"
                   :iconName="'icon--pv-plug'"
                   :disabled="$i18n.locale === 'ja'"
                   @click="$router.push({ name: 'managePlan', params: { action: 'chargePv' } })">
          {{ $t('common.chargePv') }}
        </ui-button>
      </div>
    </div>
  </content-box>
</template>

<script>
import ContentBox from '@/components/ui/ContentBox'
import UiButton from '@/components/ui/UiButton'

export default {
  name: 'DashboardNoPage',
  components: {
    ContentBox,
    UiButton
  }
}
</script>

<style lang="scss">
.content--wrap {
  &.no-page {
    margin: 180px auto 0;
    overflow: hidden;
    border-radius: 40px;
    background-color: #2f2f2f;
    background-image: url(../../assets/img/dashboard/bg_dashboard_nopv.png);
    background-size: contain;

    .content__top {
      position: relative;
      height: 360px;
      padding: 92px 30px 10px;
      box-sizing: border-box;

      .title {
        color: #ffffff;
        font-size: 52px;
        line-height: 1.05;

        span {
          display: block;
          color: #ec0047;
        }
      }

      .slogan {
        margin-top: 15px;
        font-size: 18px;
        font-weight: 600;
        line-height: 1.44;
        color: #aaaaaa;
      }

      .icon--dashboard-encourage-graph {
        position: absolute;
        bottom: calc(0px - 15px);
        right: 0;
      }
    }
    .content__bottom {
      align-items: center;
      height: 90px;
      padding-left: 34px;
      padding-right: 30px;
      background-color: #fff;
      text-align: right;
      position: relative;

      .button__wrap {
        width: 100%;
        text-align: right;

        button {
          margin-left: 5px;
        }
      }
    }

    &.ja {
      .content__top .slogan {
        margin-top: 20px;
      }
    }
  }
}
</style>
